module.exports = __webpack_public_path__ + "static/img/next_level_active.e58adc87.png";